import { useEffect, useState, useRef } from 'react';
import { GetEmployeeServiceBooks, getServiceBookTypes, InsertserviceBook, ServiceBookRemove } from '../../services/dataService';
import { IMAGE_URL } from '../../services/apiGateway';
import toast from 'react-hot-toast';
import Loading from '../../components/common/Loading';
import { getSecureItem } from '../../services/SecureStorage';

function EmployeeServiceBook({ EmpId, onclose }) {
  const UID = getSecureItem('userId');

  const [serviceBookType, setServiceBookType] = useState([]);
  const [employeeServiceBooks, setEmployeeServiceBooks] = useState([]);
  const [loading, setloading] = useState(false);

  const [serviceBookEntries, setServiceBookEntries] = useState([{
    EnterDate: "",
    Discription: "",
    Type: "",
    Document: "", // Base64 string
  }]);

  // Create refs for file inputs
  const fileInputRefs = useRef([]);

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const res = await getServiceBookTypes(UID);
        setServiceBookType(res.data.data);
      } catch (error) {
        console.error("Error fetching service book types:", error);
      }
    };
    fetchTypes();
  }, [UID]);

  const fetchServiceBooks = async () => {
    const data = {
      UserId: UID,
      EmpId: EmpId
    }
    console.log(data, 'fetchServiceBooks data');
    try {
      const res = await GetEmployeeServiceBooks(data);
      console.log('Service booksss response:', res);
      setEmployeeServiceBooks(res.data.data[0]);
    } catch (error) {
      console.error("Error fetching service book entries:", error);
    }
  };

  useEffect(() => {
    if (EmpId && UID) {
      fetchServiceBooks();
    }
  }, [EmpId, UID]);

  // Image compression function
  const compressImage = (file, quality = 0.7) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        const maxWidth = 800;
        const maxHeight = 800;
        let { width, height } = img;

        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedBase64);
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const openDocumentInNewTab = (document, fileName = 'document') => {
    if (document) {
      let documentUrl;

      if (document.startsWith('ServiceBook')) {
        documentUrl = `${IMAGE_URL}/${document}`;
        window.open(documentUrl, '_blank');
      } else if (document.startsWith('data:application/pdf;base64,')) {
        try {
          const base64Data = document.split(',')[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          documentUrl = URL.createObjectURL(blob);
          window.open(documentUrl, '_blank');
          setTimeout(() => URL.reverseObjectURL(documentUrl), 1000);
        } catch (error) {
          console.error('Error opening PDF in new tab:', error);
          toast.error('Failed to open PDF. The file may be corrupted.');
        }
      } else if (document.startsWith('data:image')) {
        try {
          const mimeType = document.match(/^data:(image\/[a-z]+);base64,/)[1];
          const base64Data = document.split(',')[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mimeType });
          documentUrl = URL.createObjectURL(blob);
          window.open(documentUrl, '_blank');
          setTimeout(() => URL.revokeObjectURL(documentUrl), 1000);
        } catch (error) {
          console.error('Error opening image in new tab:', error);
          toast.error('Failed to open image. The file may be corrupted.');
        }
      } else {
        console.error('Unsupported document format:', document);
        toast.error('Unsupported document format.');
      }
    } else {
      toast.error('No document available to view.');
    }
  };

  const getDocumentIcon = (document) => {
    if (!document) return '📄';

    if (document.startsWith('data:image') || document.startsWith('ServiceBook')) {
      return '🖼️';
    } else if (document.includes('pdf')) {
      return '📄';
    }
    return '📄';
  };

  const handleChange = async (index, e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      if (file) {
        try {
          let processedFile;

          if (file.type.startsWith('image/')) {
            processedFile = await compressImage(file);
          } else {
            processedFile = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(file);
            });
          }

          setServiceBookEntries(prev => {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              Document: processedFile
            };
            return updated;
          });
        } catch (error) {
          console.error("Error processing file:", error);
        }
      } else {
        setServiceBookEntries(prev => {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            Document: ""
          };
          return updated;
        });
        // Reset file input
        if (fileInputRefs.current[index]) {
          fileInputRefs.current[index].value = "";
        }
      }
    } else {
      setServiceBookEntries(prev => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          [name]: value
        };
        return updated;
      });
    }
  };

  const addServiceBookEntry = () => {
    setServiceBookEntries(prev => [...prev, {
      EnterDate: "",
      Discription: "",
      Type: "",
      Document: ""
    }]);
    // Ensure refs array is updated
    fileInputRefs.current.push(null);
  };

  const removeServiceBookEntry = async (Id, index) => {
    if (Id) {
      try {
        const data = { UserId: UID, Id: Id };
        const response = await ServiceBookRemove(data);
        if (response.status === 200) {
          toast.success("Service book entry removed successfully.");
          await fetchServiceBooks();
        }
      } catch (error) {
        console.error("Error removing service book entry:", error);
        alert("Error removing service book entry. Please try again.");
      }
    } else {
      if (serviceBookEntries.length > 1) {
        setServiceBookEntries(prev => prev.filter((_, i) => i !== index));
        // Remove corresponding ref
        fileInputRefs.current.splice(index, 1);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = serviceBookEntries.every(entry =>
      entry.EnterDate && entry.Discription && entry.Type
    );

    if (!isValid) {
      alert("Please fill in all required fields for each service book entry.");
      return;
    }
    setloading(true);

    const dataToSubmit = serviceBookEntries.map(entry => ({
      ...entry,
      EmpId: EmpId,
      UserId: UID
    }));
    console.log("Submitting data:", dataToSubmit);
    try {
      const response = await InsertserviceBook(dataToSubmit);
      console.log("Submitted successfully", response);
      toast.success("Service book entries submitted successfully!");
      // Reset form and file inputs
      setServiceBookEntries([{
        EnterDate: "",
        Discription: "",
        Type: "",
        Document: ""
      }]);
      // Clear all file inputs
      fileInputRefs.current.forEach(ref => {
        if (ref) ref.value = "";
      });
      fileInputRefs.current = [null]; // Reset refs array
      await fetchServiceBooks();
    } catch (error) {
      console.error("Error submitting service book:", error);
      alert("Error submitting service book entries. Please try again.");
    }
    setloading(false);
  };

  const handleReset = () => {
    setServiceBookEntries([{
      EnterDate: "",
      Discription: "",
      Type: "",
      Document: ""
    }]);
    // Clear all file inputs
    fileInputRefs.current.forEach(ref => {
      if (ref) ref.value = "";
    });
    fileInputRefs.current = [null]; // Reset refs array
  };

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6 max-h-[60vh] overflow-auto cus-scrollbar">
      <div className="flex justify-between items-center p-4 bg-white shadow-sm border-b">
      </div>

      <div className="">
        {employeeServiceBooks.length > 0 && (
          <div className="bg-white rounded-lg shadow-md">
            <div className="p-4 bg-gray-100 border-b">
              <h3 className="text-lg font-semibold text-gray-800">Existing Service Book Entries</h3>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      S.No
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Type
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Document
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {employeeServiceBooks.map((book, index) => (
                    <tr key={book.Id || index} className="hover:bg-gray-50">
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {index + 1}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {new Date(book.EnterDate).toLocaleDateString()}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        <span className="">
                          {book.TypeName || book.Type}
                        </span>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-900 max-w-xs">
                        <div className="truncate" title={book.Discription}>
                          {book.Discription}
                        </div>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                        {book.Document ? (
                          <button
                            onClick={() => openDocumentInNewTab(book.Document, `service-book-${book.Id}`)}
                            className="flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:underline"
                          >
                            <span>{getDocumentIcon(book.Document)}</span>
                            View Document
                          </button>
                        ) : (
                          <span className="text-gray-400">No document</span>
                        )}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          onClick={() => removeServiceBookEntry(book.Id, index)}
                          className="text-red-600 hover:text-red-900 hover:bg-red-50 px-2 py-1 rounded transition-colors"
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-1 bg-gray-100 border-b">
            <h3 className="text-lg font-semibold text-gray-800 ">
              Add New Service Book Entries
            </h3>
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={addServiceBookEntry}
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
              >
                + Add New
              </button>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-4">
            <div className="space-y-6">
              {serviceBookEntries.map((entry, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                  <div className="flex justify-between items-center mb-4">
                    <h4 className="text-lg font-semibold text-gray-700">New Entry #{index + 1}</h4>
                    {serviceBookEntries.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeServiceBookEntry(null, index)}
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition-colors"
                      >
                        Remove
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Choose Date <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        name="EnterDate"
                        value={entry.EnterDate}
                        onChange={(e) => handleChange(index, e)}
                        className="block w-full border border-gray-300 rounded-md p-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Choose Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="Type"
                        value={entry.Type}
                        onChange={(e) => handleChange(index, e)}
                        className="block w-full border border-gray-300 rounded-md p-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        required
                      >
                        <option value="">-- Select Type --</option>
                        {serviceBookType.map((el) => (
                          <option key={el.Id} value={el.Id}>
                            {el.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="mt-8 flex flex-col md:flex-row gap-x-6 gap-y-6">
                    <div className="flex-1 min-w-[300px]">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Enter Description <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="Discription"
                        value={entry.Discription}
                        onChange={(e) => handleChange(index, e)}
                        className="block w-full border border-gray-300 rounded-md p-2.5 h-24 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="Enter description..."
                        required
                      />
                    </div>

                    <div className="flex-1 min-w-[300px]">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Upload Document <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="file"
                        name="Document"
                        required
                        accept="image/*,.pdf"
                        onChange={(e) => handleChange(index, e)}
                        ref={el => fileInputRefs.current[index] = el}
                        className="block w-full border border-gray-300 rounded-md p-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      />
                      <p className="text-sm text-gray-500 mt-2">
                        Accepted formats: Images (JPG, PNG, etc.) and PDF files. Images will be compressed automatically.
                      </p>
                    </div>
                  </div>

                  {entry.Document && (
                    <div className="mt-4">
                      <h4 className="text-sm font-medium text-gray-700 mb-2">Preview:</h4>
                      <div className="flex items-center gap-2">
                        {entry.Document.startsWith('data:image') ? (
                          <>
                            <img
                              src={entry.Document}
                              alt="Preview"
                              className="max-w-32 max-h-32 object-contain border border-gray-300 rounded"
                            />
                            <button
                              type="button"
                              onClick={() => openDocumentInNewTab(entry.Document, `preview-${index}`)}
                              className="text-blue-600 hover:text-blue-800 hover:underline text-sm"
                            >
                              View File in New Tab
                            </button>
                          </>
                        ) : (
                          <div className="p-3 bg-gray-100 border border-gray-300 rounded flex items-center justify-between">
                            <p className="text-sm text-gray-600">📄 PDF file uploaded</p>
                            <button
                              type="button"
                              onClick={() => openDocumentInNewTab(entry.Document, `preview-${index}`)}
                              className="text-blue hover:text-blue-800 hover:underline text-sm"
                            >
                              View File
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="flex gap-4 mt-6 pt-4 border-t">
              <button
                type="submit"
                disabled={loading}
                className={`px-6 py-2 rounded focus:outline-none focus:ring-2 transition-colors ${loading
                  ? 'bg-gray-400 text-white cursor-not-allowed'
                  : 'bg-blue text-white hover:bg-blue-700 focus:ring-blue-500'
                  }`}
              >
                {loading ? 'Loading...' : `Submit All Entries (${serviceBookEntries.length})`}
              </button>

              <button
                type="button"
                onClick={handleReset}
                disabled={loading}
                className={`px-6 py-2 rounded focus:outline-none focus:ring-2 transition-colors ${loading
                  ? 'bg-gray-400 text-white cursor-not-allowed'
                  : 'bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-500'
                  }`}
              >
                Reset All
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EmployeeServiceBook;